import type { IArticleCategory } from '../models';
type TIsArticlesCategoriesVisibleParams = {
    articleCategories?: IArticleCategory[];
    existingCategories?: IArticleCategory[];
    hideCategoriesFilter?: boolean;
    isError: boolean;
};
export const isArticlesCategoriesVisible = ({
    articleCategories,
    existingCategories,
    hideCategoriesFilter,
    isError,
}: TIsArticlesCategoriesVisibleParams) =>
    !hideCategoriesFilter &&
    !isError &&
    articleCategories &&
    existingCategories &&
    existingCategories.length > 0;
